module.exports = __webpack_public_path__ + "static/media/st-payment-waiting.19705426.svg";